import React from 'react';

import Resizable from '@Components/Resizable';
import { DIRECTION_LEFT, DIRECTION_TOP } from '@Components/Resizable/constants';
import './PlacementDocked.scss';
import PropTypes from 'prop-types';
import { PLACEMENT_RIGHT, PLACEMENT_BOTTOM } from '../constants';

const resizeDirections = {
  [PLACEMENT_RIGHT]: DIRECTION_LEFT,
  [PLACEMENT_BOTTOM]: DIRECTION_TOP,
};

function PlacementDocked({ placement, isShown, onResize, onResizeAA, children }) {
  return isShown ? (
    <Resizable
      direction={resizeDirections[placement]}
      className={`rx-flex-0 rx-flex-column-container project-route-conditions-placement-docked project-route-conditions-placement-docked--${placement}`}
      useFlexBasis
      resizeHandleLabel="Resize reaction conditions panel"
      onResize={onResize}
      onDragEnd={onResizeAA}>
      {children}
    </Resizable>
  ) : null;
}
PlacementDocked.propTypes = {
  placement: PropTypes.oneOf([PLACEMENT_RIGHT, PLACEMENT_BOTTOM]).isRequired,
  isShown: PropTypes.bool,
  onResize: PropTypes.func,
  onResizeAA: PropTypes.func,
};

export default PlacementDocked;
